import src from "IMAGE";
export default { src, width: 771, height: 600, blurWidth: 0, blurHeight: 0};
